var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPremium)?_c('div',{staticClass:"my-3 md:my-5 overflow-hidden rounded shadow"},[(_vm.showPremium)?_c('GoPremium',{attrs:{"variant":_vm.variant}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }